export type PersonNameFields = {
  firstName?: string | null;
  lastName?: string | null;
};

/** Trims leading/trailing whitespace from a single name part. */
export function trimNamePart(value?: string | null): string {
  return (value ?? '').trim();
}

/** Joins trimmed first and last name with a single space; omits empty parts. */
export function formatPersonName(firstName?: string | null, lastName?: string | null): string {
  return [trimNamePart(firstName), trimNamePart(lastName)].filter(Boolean).join(' ');
}

/** Trims firstName/lastName on a user payload before API calls. */
export function withTrimmedPersonNames<T extends PersonNameFields>(data: T): T {
  const result = { ...data };
  if (data.firstName !== undefined) {
    result.firstName = trimNamePart(data.firstName);
  }
  if (data.lastName !== undefined) {
    result.lastName = trimNamePart(data.lastName);
  }
  return result;
}

export function withTrimmedPersonNamesBatch<T extends PersonNameFields>(items: T[]): T[] {
  return items.map(withTrimmedPersonNames);
}
